<span [innerHTML]="emojiSub | async" [style.fontSize]="size"></span>
